<template>
	<div class="container">
		<div class="row">
			<div class="col-3 col-md-3">
				<div class="row">
					<div class="col-12 col-md-12">
						<p class="fw-bold">{{ getFullName }}</p>
					</div>
					<div class="col-12 col-md-12 small">
						<div class="d-flex">
							<p class="mb-0 fw-bold me-3">Status:</p>
							<p class="mb-0">{{ fixed_deposit.status }}</p>
						</div>
						<div class="d-flex">
							<p class="mb-0 fw-bold me-3">Tenure:</p>
							<p class="mb-0">
								{{ fixed_deposit.fixed_deposit_product?.name }}
							</p>
						</div>
						<div class="d-flex">
							<p class="mb-0 fw-bold me-3">Interest Rate:</p>
							<p class="mb-0">
								{{ fixed_deposit.interest_rate }} %
							</p>
						</div>
						<div class="d-flex">
							<p class="mb-0 fw-bold me-3">Interest Expected:</p>
							<p class="mb-0">
								{{
									displayNumber(
										fixed_deposit.interest_expected
									)
								}}
							</p>
						</div>
						<div class="d-flex">
							<p class="mb-0 fw-bold me-3">Maturity Value:</p>
							<p class="mb-0">
								{{
									displayNumber(fixed_deposit.maturity_value)
								}}
							</p>
						</div>
						<div class="d-flex">
							<p class="mb-0 fw-bold me-3">Daily Interest:</p>
							<p class="mb-0">
								{{
									displayNumber(fixed_deposit.daily_interest)
								}}
							</p>
						</div>
						<div class="d-flex">
							<p class="mb-0 fw-bold me-3">Total Interest:</p>
							<!-- <p class="mb-0">{{ loan.interest_balance - loan.interest_paid }}</p> -->
							<p class="mb-0">
								{{
									Number(
										fixed_deposit.total_interest
									).toFixed(2)
								}}
							</p>
						</div>
						<div class="d-flex">
							<p class="mb-0 fw-bold me-3">Interest Due:</p>
							<p class="mb-0">
								{{
									Number(fixed_deposit.interest_due).toFixed(
										2
									)
								}}
							</p>
						</div>
					</div>
				</div>
			</div>
			<!-- <div class="col-3 col-md-3 small">
                <div class="row h-100">
                    <div class="col-md-12">
                        <div> <span class="fw-bold me-3">Loan Type:</span> {{ loan?.loan_product.name }}
                        </div>
                        <div> <span class="fw-bold me-3">Disbursement Date:</span> {{
                            loan?.interest_start_date }}
                        </div>
                        <div> <span class="fw-bold me-3">Maturity Date:</span> {{ loan?.maturity_date }}
                        </div>
                        <div> <span class="fw-bold me-3">Loan Premium Plan:</span> {{ institution?.currency_code }} {{
                            loan?.lpp_value }}
                        </div>
                        <div> <span class="fw-bold me-3">Other Loan Charges:</span> {{ institution?.currency_code }} {{
                            loan?.other_charges }}
                        </div>
                    </div>
                    <div class="col-md-12 mt-auto">
                        <div class="row">
                            <div class="fw-bold me-3">Principal Disbursed: <span class="fw-normal">{{
                                    institution?.currency_code }} {{ Number(loan.principal_amount).toFixed(2) }}</span>
                            </div>
                            <div class="fw-bold me-3">Principal Paid: <span class="fw-normal">{{
                                    institution?.currency_code }} {{ Number(loan.principal_paid).toFixed(2) }}</span>
                            </div>
                            <div class="fw-bold me-3">Principal Bal: <span class="fw-normal">{{
                                    institution?.currency_code }} {{ Number(loan.principal_balance).toFixed(2) }}</span>
                            </div>
                            <div class="fw-bold me-3">Principal Due: <span class="fw-normal">{{
                                    institution?.currency_code }} {{ Number(loan.principal_due).toFixed(2) }}</span>
                            </div>
                        </div>

                    </div>

                </div>
            </div> -->
			<!-- <div class="col-3 col-md-3 small">
                <div class="row h-100">
                    <div class="col-md-12">
                        <div> <span class="fw-bold me-3">Loan Code:</span> {{ loan.loan_number }}</div>
                        <div> <span class="fw-bold me-3">Last Payment Date:</span> {{ loan.last_payment }}
                        </div>
                        <div> <span class="fw-bold me-3">Delinquency:</span> {{ loan.delinquent }}</div>
                        <div> <span class="fw-bold me-3">Loan Processing Fees:</span> {{ institution?.currency_code }}
                            {{ loan?.lpf_value }}
                        </div>
                    </div>
                    <div class="col-md-12 mt-auto">
                        <div class="row">
                            <div class="fw-bold me-3">Current Value: <span class="fw-normal">{{
                                    institution?.currency_code }} {{ getCurrentValue }}</span></div>
                         
                            <div class="fw-bold me-3">Loan Balance: <span class="fw-normal"> {{
                                    institution?.currency_code }} {{ getLoanBalance }}</span></div>
                          
                            <div class="fw-bold me-3">Share Bal: <span class="fw-normal"> {{ institution?.currency_code
                                    }} {{ Number(loan?.shares_account_balances).toFixed(2) }}</span></div>
                         
                            <div class="fw-bold me-3">Saving Bal: <span class="fw-normal"> {{ institution?.currency_code
                                    }} {{ Number(loan?.savings_account_balances).toFixed(2) }}</span></div>
                         
                        </div>
                    </div>
                </div>
            </div> -->
		</div>
	</div>
</template>
<script>
	export default {
		props: ["institution", "fixed_deposit"],
		computed: {
			getFullName() {
				const first_name =
					this.fixed_deposit?.account?.customer?.first_name !=
					undefined
						? this.fixed_deposit?.account?.customer?.first_name
						: "";
				const middle_name =
					this.fixed_deposit?.account?.customer?.middle_name !=
					undefined
						? this.fixed_deposit?.account?.customer?.middle_name
						: "";
				const last_name =
					this.fixed_deposit?.account?.customer?.last_name !=
					undefined
						? this.fixed_deposit?.account?.customer?.last_name
						: "";
				return first_name + " " + middle_name + " " + last_name;
			},
		},

		// methods: {
		//     filterFixedDeposit(){
		//         this.filterFixedDepositStatement();
		//     },
		//     filterFixedDepositStatement() {
		//         // console.log(this.filter.start_date);
		//         // console.log(this.loan.loan_number)
		//         this.search = "processing...";
		//         this.isSearching = true;
		//         ApiService.query("/investments/fixedDepositStatements", {
		//             params: {
		//                 fd_code: this.fixed_deposit?.code,
		//                 start_date: this.adv_filter?.start_date,
		//                 end_date: this.adv_filter?.end_date,
		//             }
		//         }).then((response) => {
		//             // console.log('details',response.data.data);
		//             this.details = response.data.data;
		//             // console.log(this.details);
		//             this.isLoading = false;
		//             // console.log(response.data.data.account.transactions);
		//             this.statement_items = response.data.data.account.transactions.map((index) => {
		//                 return {
		//                     id: index.id,
		//                     trans_date: index.trans_date,
		//                     transaction_type: index.transaction_type,
		//                     transaction_mode: index.transaction_mode,
		//                     trans_amount: index.trans_amount,
		//                     debit: Math.round(index.debit * 100) / 100,
		//                     credit: Math.round(index.credit * 100) / 100,
		//                     previous_balance: Math.round(index.previous_balance * 100) / 100,
		//                     principal: Math.round(index.principal * 100) / 100,
		//                     principal_paid: Math.round(index.principal_paid * 100) / 100,
		//                     principal_balance:Math.round(index.principal_balance * 100) / 100,
		//                     interest_paid: Math.round(index.interest_paid * 100) / 100,
		//                     interest_balance: Math.round(index.interest_balance * 100) / 100,
		//                     interest: Number(index.interest).toFixed(2),
		//                     denominations: index.denominations,
		//                     loan_interest_due: index.loan_interest_due,
		//                     loan_principal_due: index.loan_principal_due,
		//                     cheque_number: index.cheque_number,
		//                     code: index.code
		//                 }
		//             });
		//             // this.handleImageLoad();
		//             this.search = "Search";
		//             this.isSearching = false;
		//         }).catch((error) => {
		//             this.search = "Search";
		//             this.isSearching = false;
		//             // console.log(error)
		//             if (error.response.status == 404) {
		//                 swal.fire({
		//                     icon: "error",
		//                     title: error.response.statusText,
		//                     text: "Something went wrong!",
		//                     showCancelButton: false, // Show the "Cancel" button
		//                     confirmButtonText: 'OK', // Customize the text for the "OK" button
		//                     buttonsStyling: false, // Disable SweetAlert2 styling for buttons
		//                     customClass: {
		//                         confirmButton: 'btn btn-size akkurate-green-btn modal-btn-width text-white me-2', // Custom class for the "OK" button
		//                     }
		//                     // footer: '<a href="#">Why do I have this issue?</a>'
		//                 });
		//             }
		//         })
		//     },
		//     getOneMonthBeforeDate() {
		//         // Get today's date
		//         let currentDate = new Date();

		//         // Remove one month to the current date
		//         currentDate.setMonth(currentDate.getMonth() - 1);

		//         // Format the date as 'YYYY-MM-DD'
		//         return currentDate.toISOString().substr(0, 10);
		//     },
		//     downloadPDF() {

		//         const content = this.$refs.pdfContent; // Reference to the HTML content you want to convert
		//         // console.log("here");
		//         const pdfOptions = {
		//             margin: [0.3, 0.1, 1.2, 0.1],
		//             filename: 'statement.pdf',
		//             image: { type: 'jpeg', quality: 0.98 },
		//             html2canvas: { scale: 2 },
		//             jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' },
		//         };
		//         html2pdf()
		//             .from(content)
		//             .set(pdfOptions)
		//             .toPdf()
		//             .get('pdf')
		//             .then((pdf) => {
		//                 var totalPages = pdf.internal.getNumberOfPages();
		//                 var insit_name = this.institution.name;
		//                 var insit_tele = this.institution.telephone;
		//                 var insit_email = this.institution.email;
		//                 var insit_motto = this.institution.motto;

		//                 for (var i = 1; i <= totalPages; i++) {
		//                     pdf.setPage(i);
		//                     pdf.setFontSize(8);
		//                     pdf.setTextColor(150);
		//                     pdf.text(["For Inquiries, Please Contact " + insit_name + ", Customer Service on " + insit_tele + "", "or email us on " + insit_email + " " + insit_motto + "", "Page " + i + " of " + totalPages], pdf.internal.pageSize.getWidth() / 2, pdf.internal.pageSize.getHeight() - 0.6, { align: "center" });
		//                 }
		//             }).save();

		//     },
		//     printPDF() {
		//         const content = this.$refs.pdfContent; // Reference to the HTML content you want to convert
		//         // console.log("here");
		//         const pdfOptions = {
		//             margin: [0.3, 0.1, 1.2, 0.1],
		//             filename: 'statement.pdf',
		//             image: { type: 'jpeg', quality: 0.98 },
		//             html2canvas: { scale: 2 },
		//             jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' },
		//         };
		//         html2pdf()
		//             .from(content)
		//             .set(pdfOptions)
		//             .toPdf()
		//             .get('pdf')
		//             .then((pdf) => {
		//                 var totalPages = pdf.internal.getNumberOfPages();
		//                 var insit_name = this.institution.name;
		//                 var insit_tele = this.institution.telephone;
		//                 var insit_email = this.institution.email;
		//                 var insit_motto = this.institution.motto;

		//                 for (var i = 1; i <= totalPages; i++) {
		//                     pdf.setPage(i);
		//                     pdf.setFontSize(8);
		//                     pdf.setTextColor(150);
		//                     pdf.text(["For Inquiries, Please Contact " + insit_name + ", Customer Service on " + insit_tele + "", "or email us on " + insit_email + " " + insit_motto + "", "Page " + i + " of " + totalPages], pdf.internal.pageSize.getWidth() / 2, pdf.internal.pageSize.getHeight() - 0.6, { align: "center" });
		//                 }

		//                 // Get the blob of the PDF
		//                 return pdf.output("blob");
		//             })
		//             .then((pdfBlob) => {
		//                 // Create a URL for the PDF blob
		//                 var pdfUrl = URL.createObjectURL(pdfBlob);

		//                 // Open the URL in a new tab
		//                 const printWindow = window.open(pdfUrl, '_blank', 'width=800,height=600');
		//                 printWindow.onload = () => {
		//                     printWindow.print();
		//                     // URL.revokeObjectURL(url);
		//                 };
		//             })
		//             .catch((error) => {
		//                 console.error("Error generating PDF:", error);
		//             });
		//     },
		// }
	};
</script>
